/**
 * Repayments List Page
 */
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchRepayments } from '../repaymentSlice';

const RepaymentsList = () => {
  const dispatch = useDispatch();
  const { repayments, isLoading } = useSelector((state) => state.repayments);

  useEffect(() => {
    dispatch(fetchRepayments());
  }, [dispatch]);

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-gray-900 dark:text-white">Repayments</h1>
        <p className="text-gray-600 dark:text-gray-400">Track loan repayments</p>
      </div>

      {isLoading ? (
        <div className="text-center py-8">Loading...</div>
      ) : (
        <div className="bg-white dark:bg-gray-800 rounded-lg shadow p-6">
          {repayments.length > 0 ? (
            <div>Repayments data will be displayed here</div>
          ) : (
            <div className="text-center text-gray-500">No repayments found</div>
          )}
        </div>
      )}
    </div>
  );
};

export default RepaymentsList;
